import React, { useEffect, useState } from "react"
import IssuesFeed from "~/react/components/issues-feed"
import type { CampaignIssue } from "~/types/serializers"

interface CampaignsIssuesProps {
  endpoint: string
  refreshInterval?: number
}

const CampaignsIssues: React.FC<CampaignsIssuesProps> = ({
  endpoint,
  refreshInterval,
}) => {
  const [issues, setIssues] = useState<CampaignIssue[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchIssues = () => {
      fetch(endpoint, {
        headers: {
          Accept: "application/json",
        },
        credentials: "same-origin",
      })
        .then((res) => {
          if (!res.ok) throw new Error(`HTTP error ${res.status}`)
          return res.json()
        })
        .then(setIssues)
        .catch((error) => {
          console.error("Failed to fetch campaign issues:", error)
        })
        .finally(() => setLoading(false))
    }

    fetchIssues()

    if (refreshInterval && refreshInterval > 0) {
      const interval = setInterval(fetchIssues, refreshInterval)
      return () => clearInterval(interval)
    }
  }, [endpoint, refreshInterval])

  return (
    <IssuesFeed
      issues={issues}
      loading={loading}
      title={i18n.t("js.campaigns.issues.title")}
      tooltip={i18n.t("js.campaigns.issues.tooltip")}
      emptyStateTitle={i18n.t("js.campaigns.issues.empty_state.title")}
      emptyStateDescription={i18n.t(
        "js.campaigns.issues.empty_state.description",
      )}
    />
  )
}

export default CampaignsIssues
